import { Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function FieldErrorsMessage({ errorType, message }) {
    const { fieldErrors } = useBoundContext()

    const fields = Object.values(fieldErrors)
        .filter((item) => item.errorTypes.includes(errorType))
        .map("field")

    return fields.length > 0 && <Typography variant="body2">{message(fields)}</Typography>
}
